import styled from "styled-components";
import React, { memo } from "react";
import { color } from "../../../helpers/color";
import Cursor from "./Cursor";
import { useScope } from "./state/scope";
const Root = /*#__PURE__*/memo(styled.div.withConfig({
  displayName: "Root",
  componentId: "sc-1jnnf6o-0"
})(["position:absolute;z-index:2;top:0;left:0;width:14px;height:14px;border-radius:10px;background-color:", ";transform:translate(-7px,-7px);"], color));
Root.defaultProps = {
  color: "primary"
};
const Handle = /*#__PURE__*/memo(({
  y,
  color,
  active,
  position,
  children
}) => {
  const {
    start,
    length
  } = useScope();
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Cursor, {
    active: active,
    color: color,
    position: position
  }, children), /*#__PURE__*/React.createElement(Root, {
    color: color,
    style: {
      top: y,
      left: `${(position - start) / length * 100}%`
    }
  }));
});
export default Handle;
//# sourceMappingURL=Handle.js.map